<template>
    <div>
        <myPage>
            <div class="flex-box nopadding wrap pd-left5 pd-bottom5" slot="header">
                <div class="f-bd f14 text-nowrap">{{$t('add_time')}}{{$t('x_mh')}}</div>
                <div class="mg-right5 mg-top5"><myDatePicker v-model="search.datearea_id" @onChange="onDateChange"></myDatePicker></div>
                <div class="mg-right5 mg-top5">
                    <el-input size="small" v-model="search.err_cname">
                        <span slot="prepend">{{$t('cname')}}{{$t('x_yd')}}</span>
                    </el-input>
                </div>
                <div class="mg-top5"><el-button size="small" @click="list()">{{$t('list')}}</el-button></div>
            </div>
            <div class="fillw fillh">
                <el-table class="el-table--border" :data="listData" height="100%">
                    <el-table-column width="150px" prop="err_type_cdesc">
                        <template slot-scope="scope" slot="header">
                            <myDropdown :title="listHeader.err_type_cdesc" :list="err_type" v-model="search.err_type"
                                        title_class="f12 f-blue" key_name="value" value_name="key" @onChange="list()"></myDropdown>
                        </template>
                    </el-table-column>
                    <el-table-column prop="err_cname" :label="listHeader.err_cname" width="200px"></el-table-column>
                    <el-table-column prop="err_cdesc" :label="listHeader.err_cdesc" min-width="200px"></el-table-column>
                    <el-table-column prop="add_time" :label="listHeader.add_time" width="150px"></el-table-column>
                </el-table>
            </div>
            <div slot="footer">
                <myPager slot="footer" :limit="search.limit" @onLimitChange="onLimitChange"
                         v-model="search.page" :pageSize="search.pageSize" @onPagerChange="onPagerChange"></myPager>
            </div>
        </myPage>
        <myDrawer v-model="show_subview">
            <router-view></router-view>
        </myDrawer>
    </div>
</template>

<script>
    import myDatePicker from "../../components/myDatePicker"
    import myPager from '../../components/myPager'
    import myDropdown from '../../components/myDropdown'
    export default {
        name:'system-errhigh',
        components:{
            myDatePicker,
            myPager,
            myDropdown
        },
        data:function(){
            const listHeader = {
                err_type_cdesc: this.$t('cat'),
                err_cname: this.$t('cname'),
                err_cdesc: '描述',
                add_time: this.$t('add_time')
            };
            return{
                self:this,
                table_height: 200,
                sub_title:"",//子界面名称
                show_subview:false,
                relist:false,
                search:{
                    search_url: "system/errhigh-list",
                    datearea_id:0,//如果大于0 mounted 要删除date_fr date_to
                    date_fr: '',
                    date_to: '',
                    page: 1,
                    limit: 30,
                    pageSize: 0,
                    err_cname: '',
                    err_type: '',
                },
                listHeader,//表结构
                listData: [],
                totalData: {
                    total: 0,//总行数
                },
                err_type:[
                    {
                        key:'',
                        value:this.$t('all')
                    }
                ],
            }
        },
        activated:function(){
            this.$base.setMenuOpens();
        },
        mounted: function(){
            this.$base.setMenuOpens();
            this.$base.listPageInit(this,()=>{
                this.getLoad();
            });
        },
        methods:{
            onDateChange: function(data){
                this.search.date_fr = data[0];
                this.search.date_to = data[1];
            },
            onPagerChange: function () {
                this.list(true);
            },
            onLimitChange: function (limit) {
                this.search.limit = limit;
                this.list();
            },
            getLoad: function () {
                this.$base.showLoading();
                this.$request.sendPost("system/errhigh-before-list",{},(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.err_type = this.err_type.concat(data.err_type);
                        this.list()
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            list: function (change_page) {
                this.$base.list(this, change_page);
            },
            exportExcel: function(){
                this.$base.exportExcel(this);
            }
        },
        watch:{
            //界面重新加载数据
            relist:function (newVal,oldVal) {
                if(newVal){
                    this.list(true);
                    this.relist = false;
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/system/errhigh.vue